<script type="text/javascript">
	import { onMount, onDestroy, createEventDispatcher, tick, afterUpdate, beforeUpdate } from "svelte"
	import { get, writable } from "svelte/store"

	import API from "../../API/API"
	//import AdminStore from "./Store"

	import Image from "../../Models/Image"
	import LoadState from "../../Enums/LoadState"
	import ImageGeometryType from "../../Models/Enums/ImageGeometryType"

	import PropertyList from "../PropertyList/PropertyList"
	import PropertyListComponent from "../PropertyList/PropertyListComponent.svelte"

	import Dropzone from "svelte-file-dropzone";
	import Form from './Form.svelte';
	import Button, {Label} from '@smui/button';
	import DataTable, {Head, Body, Row, Cell} from '@smui/data-table';
	import Select, {Option} from '@smui/select';
	import Textfield, {Input, Textarea} from "@smui/textfield";
	import Icon from "@smui/textfield/icon/index";
	import SpinnerButton from "./SpinnerButton.svelte";

	import GeoHelper from "../../Helpers/GeoHelper";
	import ValidationHelper from "../../Helpers/ValidationHelper";
	import StringHelper from "../../Helpers/StringHelper";
	import { formatUnixTimestamp } from "../../Helpers/Misc/timeHelper";

	import mapbox from "mapbox-gl";
	import mapboxgl from 'mapbox-gl';
	import AuthStore from "../../Auth/Store";
	import MapStore from "../../Map/Store";
	import BoxSelect from "../../Map/BoxSelect";
	import { MAPBOX_TOKEN } from "../../../config/mapbox";

	export let image = null; // Image Model
	export let endpointNew = "admin/images/create";
	export let endpointExisting = "admin/images/{image_id}";
	export let confirmDialog = null; //AdminStore.cms.confirmDialog;
	export let canSubmit = true;

	const dispatch = createEventDispatcher(); // submit | reset | delete

	const Loading = {
		NONE: -1,
		SAVING_IMAGE: 0,
		DELETING_IMAGE: 2
	};

	let createEditable = (image) => {
		let quad = image.quad;
		if (image.geometryType=== ImageGeometryType.EXTENT) {
			quad = image.quadFromExtent;
		}
		return {
			name: image.name,
			properties: new PropertyList(image.properties),
			geometryType: image.geometryType,
			extent: [...image.extent],
			quad: [...quad]
		};
	};
	let destroyEditable = (editable) => {
		if (editable !== null) {
			editable.properties = null;
			delete editable.properties;
		}
	};
	let editable = createEditable(image);

	let form = null;
	let loading = writable(Loading.NONE);

	// let pulledImage = false;
	let localImage = null;
	let parsingLocalImage = writable(LoadState.NONE);
	let parsingLocalImageError = writable("");
	let parsingLocalImageContent = writable("");
	let parsingLocalImageSize = writable({width: 0, height: 0});

	let style = "width:100%;margin-top:10px;";
	$: if (form) form.setReadOnly($loading !== Loading.NONE);

	//let companies = AdminStore.cms.companies;

	let onReset = () => {
		destroyEditable(editable);
		editable = createEditable(image);
		//pulledImage = false;
		console.log("init/reset editable", editable);
		dispatch('reset');
	}

	let onPullImage = () => {
		$loading = Loading.PULLING_IMAGE;
		API.get("admin/images/" + image.id)
			.then((response) =>{
				console.log("response", response);
				let tmpq = editable.quad;
				let tmpe = editable.extent;
				image.setData(response);
				localImage.src = image.url;
				image = image;
				tick().then(()=>{
					onReset();
					editable.quad = tmpq;
					editable.extent = tmpe;
					//pulledImage = true;
					tryUpdateBounds();
					tryAddImageToMap();
				});
				form.snackbar.start("Image pulled successfully?", "success");
			}).catch((e)=>{
				console.error(e);
				form.snackbar.start("Image pull failed?", "error");
			}).finally(() =>{
				$loading = Loading.NONE;
			})
	}
	let onSubmit = () => {
		if (!canSubmit) {
			console.warn("canSubmit is set to false");
			return;
		}

		let file = files.accepted[0];

		let data = editable;
		data.properties = editable.properties.data;

		if (image.isNew() ) {
			data.file_name = file.name;
			data.file_size_bytes = file.size;
			data.image_data = $parsingLocalImageContent.substr($parsingLocalImageContent.indexOf(",")+1);
			data.image_width = $parsingLocalImageSize.width;
			data.image_height = $parsingLocalImageSize.height;
			$parsingLocalImageError = "";
		}
		console.log("data", data);

		// We only want to send the info that has changed... I think...
		let n = image.isNew();
		let url = n ? endpointNew : StringHelper.replaceAll(endpointExisting, "{image_id}", image.id);
		$loading = Loading.SAVING_IMAGE;
		API.put(url, data)
			.then((response) => {
				console.log("response", response);
				if (image.isNew()) {
					dispatch('added', {image:image});
				}
				image.setData(response);
				image = image;
				onReset();
				form.snackbar.start("Image " + (n ? "created" : "updated") + " successfully.", "success");
				$loading = Loading.NONE;

				if (n) {
					dispatch('submit', {image:image, returnToMenu: true});
				} else {
					dispatch('submit', {image:image, returnToMenu: false});
				}

				// TODO: Below. Some sort of infinite loop condition causing browser crashes! (^AG)

				// beforeUpdate(()=>{
				// 	console.log("beforeUpdate");
				// });
				// afterUpdate(()=>{
					// console.log("afterUpdate");
					// localImage.src = image.url;

					//pulledImage = true;
					// tick().then(()=>{
						// setTimeout(()=>{
						// 	initMap();
						// }, 200);
					// 	tryAddImageToMap();
					// })
					// $loading = Loading.NONE;
				// });
				// tick().then(() => {
				// 	console.log("tick");
				// 	localImage.src = image.url;

				// 	tick().then(() => {
				// 		initMap();
				// 	}).catch(() => {
				// 		console.error('catch 2', e);
				// 	});

				// }).catch((e) => {
				// 	console.error('catch', e);
				// })

			}).catch((e)=>{
				console.error(e);
				form.snackbar.start("Image " + (n ? "creation" : "update") + " failed.", "error");
			}).finally(() =>{
				$loading = Loading.NONE;
			})
	};
	let onDelete = () => {
		if (confirmDialog === null) {
			console.error("Dev error: please implement a ConfirmDialog.");
			return;
		}
		confirmDialog.onConfirm = () => {
			console.log('confirm');
			$loading = Loading.DELETING_IMAGE;
			API.delete("admin/images/" + image.id)
				.then((response)=>{
					console.log(response);
					form.snackbar.start("Image deleted successfully.", "success");
					dispatch('delete', {image:image});
				})
				.catch((e) => {
					console.error(e);
					form.snackbar.start("Image deletion failed.", "error");
				})
				.finally(()=>{
					$loading = Loading.NONE;
					confirmDialog.visible.set(false);
				});
		};
		confirmDialog.visible.set(true);
		// AdminStore.cms.confirmDialog.bringToTop();
		return;
	}

	let files = {
		accepted: [],
		rejected: []
	};
	function handleFilesSelect(e) {
		$parsingLocalImage = LoadState.LOADING;
		$parsingLocalImageError = "";
		$parsingLocalImageContent = "";

		const { acceptedFiles, fileRejections } = e.detail;
		files.accepted = [...files.accepted, ...acceptedFiles];
		files.rejected = [...files.rejected, ...fileRejections];

		console.log("files", files);

		if (files.accepted.length >= 1) {
			let file = files.accepted[0];
			let reader = new FileReader();
			reader.readAsDataURL(file);
			reader.onload = function () {
				console.log("Loaded");
				$parsingLocalImage = LoadState.LOADED;
				$parsingLocalImageContent = reader.result;

				console.log("localImage", localImage);
				localImage.onload = function() {
					// `naturalWidth`/`naturalHeight` aren't supported on <IE9. Fallback to normal width/height
					// The natural size is the actual image size regardless of rendering.
					// The 'normal' width/height are for the **rendered** size.

					let lwidth  = localImage.naturalWidth  || localImage.width;
					let lheight = localImage.naturalHeight || localImage.height;
					console.log("lwidth", lwidth);
					console.log("lheight", lheight);
					parsingLocalImageSize.set({
						width: lwidth,
						height: lheight
					})
					// Do something with the width and height
					let ratio = parseFloat(lwidth) / parseFloat(lheight);
					localImage.width = 256;
					localImage.height = 256 / ratio;

					if (file.size > 1024 * 1024 * 4) {
						$parsingLocalImage = LoadState.INIT;
						$parsingLocalImageError = "Max image file size is 5mb.";
					}
				}
				localImage.src = $parsingLocalImageContent;



			};
			reader.onerror = function (error) {
				console.error('Error: ', error);
				$parsingLocalImage = LoadState.INIT;
				$parsingLocalImageError = error;
			};
		}
		else {
			files.accepted = [];
			files.rejected = [];
			$parsingLocalImage = LoadState.INIT;
			$parsingLocalImageError = "Please select only one image.";
		}
	}

	let imgstyle = "clear:both;float:left;max-width:600px;";



	let extentUpdate = (e, index) => {
		console.log("extentUpdate", e.target.value, index);

		let val = parseFloat(e.target.value);
		if (!Number.isNaN(val)) {
			editable.extent[index] = val;
			tryUpdateBounds();
			tryAddImageToMap();
			//$editorChart.bounds[indexx][indexy] = val;
			//$editorChart.onBoundsChanged();
			//$lastUpdated = Date.now();
			console.log('updated');
		} else {
			console.log('err');
		}
		console.log("editable.extent", editable.extent);
	}
	let extentQuadUpdate = (e, pointIndex, axisIndex) => {
		let val = parseFloat(e.target.value);
		if (!Number.isNaN(val)) {
			editable.quad[pointIndex][axisIndex] = val;
			tryUpdateBounds();
			tryAddImageToMap();
			console.log('updated');
		} else {
			console.log('err');
		}
		console.log("editable.quad", editable.quad);
	}

	let mapContainer = null;
	let map = null;

	let tryUpdateBounds = () => {
		if (map) {
			if (editable.geometryType === ImageGeometryType.EXTENT) { 
				let coords = MapStore.helpers.generateRectCoordsFromExtent(editable.extent);
				let outline = GeoHelper.featureLineString([...coords, coords[0]]);
				map.getSource("bounds").setData(GeoHelper.emptyGeoJson([outline]));
				console.log("updated bounds", outline);
			}
			else if (editable.geometryType === ImageGeometryType.QUAD) {
				let outline = GeoHelper.featureLineString([...editable.quad, editable.quad[0]]);
				map.getSource("bounds").setData(GeoHelper.emptyGeoJson([outline]))
				console.log("updated bounds", outline);
			}
		}
	};
	let tryAddImageToMap = () => {
		if (localImage !== null && localImage.src !== "" && !image.isNew()) {
			console.log("tryAddImageToMap", localImage.src, window.location.href);
			if (localImage.src === window.location.href) {
				console.error("Image url is not yet loaded.");
				return;
			}

			if (editable.geometryType === ImageGeometryType.EXTENT) { 
				if (editable.extent[0] === 0 &&
					editable.extent[1] === 0 &&
					editable.extent[2] === 0 &&
					editable.extent[3] === 0) {
					console.error("Cannot add image to map as it has extent [0,0,0,0].");
					return;
				}
				addImageToMap(localImage.src);
			}
			else if (editable.geometryType === ImageGeometryType.QUAD) {
				if (editable.quad[0][0] === 0 &&
					editable.quad[0][1] === 0 &&
					editable.quad[1][0] === 0 &&
					editable.quad[1][1] === 0 &&
					editable.quad[2][0] === 0 &&
					editable.quad[2][1] === 0 &&
					editable.quad[3][0] === 0 &&
					editable.quad[3][1] === 0) {
					console.error("Cannot add image to map as it has quad (all zero).");
					return;
				}
				addImageToMap(localImage.src);
			}
		}
	}
	let trySetImageOpacity = () => {
		if (map) {
			if (typeof map.getSource("image") !== "undefined") {
				map.setPaintProperty("image", "raster-opacity", $opacity);
			}
		}
	};

	let boxSelect = new BoxSelect();
	boxSelect.roundTo.set(4);
	boxSelect.end.subscribe((end)=>{
		if (!editable) { return; }
		editable.extent = boxSelect.getExtent();
		tryUpdateBounds();
		tryAddImageToMap();
	})
	let boxSelectEnabled = false;

	let opacity = writable(0.75);
	$: {
		$opacity;
		trySetImageOpacity();
	}



	let lng = MapStore.homeLocation.lng;
	let lat = MapStore.homeLocation.lat;
	let zoom = MapStore.homeLocation.zoom;
	onMount(()=>{
		console.log("on mount");
		if (!image.isNew()) {
			initMap();
		}
		onReset();
		return () => {
			destroyMap();
		};
	});
	onDestroy(() => {
		console.log('on destroy');
	});

	let initMap = () => {
		console.log("init map");
		if (map !== null) {
			console.log('map already initialised');
			return;
		}
		console.log("mapContainer", mapContainer);
		let isGeollect = get(AuthStore.session.company).name === "Geollect"
		map = new mapbox.Map({
			container: mapContainer,
			accessToken: MAPBOX_TOKEN,
			style: "mapbox://styles/geollectryan/ckb2fkokp151s1ipscyj41vra",
			center: [$lng, $lat],
			zoom: $zoom
		});
		map.on("load", async () => {
			console.log("map load event");
			map.resize();
			map.on("mousedown", (event) => {
				if (boxSelectEnabled) {
					boxSelect.mouseDown(map, event);
				}
			});
			map.on("mouseup", (event) => {
				if (boxSelectEnabled) {
					boxSelect.mouseUp(map, event);
					boxSelectEnabled = false;
				}
			});
			map.on("mousemove", event => {
				if (boxSelectEnabled) {
					boxSelect.mouseMove(map, event);
				}
			});

			map.addSource("bounds", {
				type: "geojson",
				data: GeoHelper.emptyGeoJson()
			});
			map.addLayer({
				id: "bounds",
				source: "bounds",
				type: "line",
				layout: {
					"line-join": "round",
					"line-cap": "round"
				},
				paint: {
					"line-color": "#000000",
					"line-width": 2
				}
			});
			if (localImage !== null) {
				localImage.src = image.url;
			}
			tryUpdateBounds();
			tryAddImageToMap();
		});
		map.resize();
	};
	let destroyMap = () => {
		console.log('destroy map');
		if (map) {
			map.remove();
			map = null;
		}
	};

	let startDrawExtent = () => {
		boxSelectEnabled = true;
	};

	let addImageToMap = (url) => {
		console.log("addImageToMap", url);
		let coords;
		if (editable.geometryType === ImageGeometryType.EXTENT) {
			coords = MapStore.helpers.generateRectCoordsFromExtent(editable.extent);
		}
		else if (editable.geometryType === ImageGeometryType.QUAD) {
			// coords = [...editable.quad];
			coords = [
				editable.quad[3],
				editable.quad[2],
				editable.quad[1],
				editable.quad[0]
			];
		}

		if (typeof map.getSource("image") !== "undefined") {
			map.removeLayer("image");
			map.removeSource("image");
		}

		map.addSource("image", {
			type: "image",
			url: url,
			coordinates: coords
		});
		map.addLayer({
			id: "image",
			source: "image",
			type: "raster",
			paint: {
				"raster-opacity": $opacity,
				"raster-resampling": "nearest"
			}
		});
		trySetImageOpacity();
		console.log("addImageToMap complete");
	};

	let selectGeometryType = (et) => {
		let prev = editable.geometryType;
		editable.geometryType = et;

		if (prev === ImageGeometryType.EXTENT) {
			// Make a quad from the old extent
			editable.quad = GeoHelper.calcQuadFromExtent(editable.extent); // image.quadFromExtent; 
		}
		else if (prev === ImageGeometryType.QUAD) {
			// Find the bbox of the quad and make an extent
			let newExtent = GeoHelper.calcExtentFromQuad(editable.quad);
			console.log(editable.quad);
			console.log(newExtent, editable.extent);
			editable.extent = newExtent;
		}
		tryUpdateBounds();
		tryAddImageToMap();
	};

</script>

<style type="text/css">
	.image-upload-preview {
		border:1px dashed #888;
	}
</style>

<Form bind:this={form} id='admin-image-form'>
	{#if image.isNew()}
		<h2>New Image</h2>
	{:else}
		<h2>Existing Image</h2>
	{/if}

	<DataTable table$aria-label="Image" table$class={"mdc-data-table__table w-100"}>
		<Head style="display: none">
			<Row>
				<Cell></Cell>
				<Cell></Cell>
			</Row>
		</Head>
		<Body>
			<Row>
				<Cell>Name</Cell>
				<Cell>
					<Textfield dense variant="outlined" bind:value={editable.name} style="width:100%" />
				</Cell>
			</Row>
			<Row>
				<Cell>Image file</Cell>
				<Cell>
					{#if image.isNew()}
						<div style="margin-top:15px;"><Dropzone on:drop={handleFilesSelect} multiple={false} accept=".jpg,.png" /></div>
						<!-- disableDefaultStyles={true}  -->
						<ol>
							{#each files.accepted as item}
								<li>{item.name}</li>
							{/each}
						</ol>
						<img class='image-upload-preview' bind:this={localImage} style='margin-bottom:10px;'/>
					{/if}
					{#if !image.isNew()}
						{#if image.url === ""}
							<!-- disabled={(image.url !== "")}  -->
							<Button on:click={onPullImage} color="secondary" variant="unelevated" style={style+";margin-bottom:10px;"}><Label>Get Image Preview</Label></Button>
						{:else}
							<div style={imgstyle+";padding:5px;overflow-x:scroll;"} ><a href={image.url} target="new">{image.url}</a></div>
						{/if}
						<img class='image-upload-preview' style={imgstyle} bind:this={localImage}/>
					{/if}
				</Cell>
			</Row>
			{#if image.isNew() && $parsingLocalImageError.length > 0}
				<Row>
					<Cell></Cell>
					<Cell>
						<div class='msgbox bg-error'>
							{$parsingLocalImageError}
						</div>
					</Cell>
				</Row>
			{/if}
			{#if !image.isNew()}
				<Row>
					<Cell>Properties</Cell>
					<Cell>
						<PropertyListComponent name="image" propertyList={editable.properties} width={"50%"} style={"margin:10px;"}/>
					</Cell>
				</Row>
				<Row>
					<Cell>Plottable Extent</Cell>
					<Cell>

						<div bind:this={mapContainer} id="cms-image-map" style='border:1px solid #666;margin-top:10px; min-height:400px;resize:both;'>
							<!-- get box/draw set extent on this-->
							<!-- get image plot -->
						</div>
						<table style="margin-top:10px;">
							<tr>
								<td><input type='radio' name="geometryType" value='extent' checked={editable.geometryType===ImageGeometryType.EXTENT} on:click={()=>{ selectGeometryType(ImageGeometryType.EXTENT); }}><b>Extent</b> &nbsp;&nbsp;&nbsp;</td>
								<td><input type='radio' name="geometryType" value='quad'   checked={editable.geometryType===ImageGeometryType.QUAD} on:click={()=>{ selectGeometryType(ImageGeometryType.QUAD);   }}><b>Quad/Corners</b> &nbsp;&nbsp;&nbsp;</td>
							</tr>
						</table>
						<table style="margin-top:10px;">
							{#if editable.geometryType === ImageGeometryType.EXTENT}
								<tr>							
									<td>
										<Textfield dense variant="outlined"
											label="Min longitude..."
											value={editable.extent[0]}
											style="width:100%"
											on:input={(e)=>{ extentUpdate(e, 0); }}
											on:keyup={(e)=>{ extentUpdate(e, 0); }}
											/>
									</td>
									<td>
										<Textfield dense variant="outlined"
											label="Max longitude..."
											value={editable.extent[1]}
											style="width:100%"
											on:input={(e)=>{ extentUpdate(e, 1); }}
											on:keyup={(e)=>{ extentUpdate(e, 1); }}
											/>
									</td>
									<td>
										<Textfield dense variant="outlined"
											label="Min latitude..."
											value={editable.extent[2]}
											style="width:100%"
											on:input={(e)=>{ extentUpdate(e, 2); }}
											on:keyup={(e)=>{ extentUpdate(e, 2); }}
											/>
									</td>
									<td>
										<Textfield dense variant="outlined"
											label="Max latitude..."
											value={editable.extent[3]}
											style="width:100%"
											on:input={(e)=>{ extentUpdate(e, 3); }}
											on:keyup={(e)=>{ extentUpdate(e, 3); }}
											/>
									</td>
								</tr>
							{:else if editable.geometryType === ImageGeometryType.QUAD}
								<tr>
									<td align="left">
										<b>Top-left</b><br/>
										<Textfield dense variant="outlined"
											label="Lng..."
											value={editable.quad[3][0]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 3, 0); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 3, 0); }}
											/>
										<Textfield dense variant="outlined"
											label="Lat..."
											value={editable.quad[3][1]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 3, 1); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 3, 1); }}
											/>
									</td>
									<td align="right">
										<b>Top-right</b><br/>
										<Textfield dense variant="outlined"
											label="Lng..."
											value={editable.quad[2][0]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 2, 0); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 2, 0); }}
											/>
										<Textfield dense variant="outlined"
											label="Lat..."
											value={editable.quad[2][1]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 2, 1); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 2, 1); }}
											/>
									</td>
								</tr>
								<tr>
									<td align="left">
										<b>Bottom-left</b><br/>
										<Textfield dense variant="outlined"
											label="Lng..."
											value={editable.quad[0][0]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 0, 0); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 0, 0); }}
											/>
										<Textfield dense variant="outlined"
											label="Lat..."
											value={editable.quad[0][1]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 0, 1); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 0, 1); }}
											/>
									</td>
								
									<td align="right">
										<b>Bottom-right</b><br/>
										<Textfield dense variant="outlined"
											label="Lng..."
											value={editable.quad[1][0]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 1, 0); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 1, 0); }}
											/>
										<Textfield dense variant="outlined"
											label="Lat..."
											value={editable.quad[1][1]}
											style="width:49%"
											on:input={(e)=>{ extentQuadUpdate(e, 1, 1); }}
											on:keyup={(e)=>{ extentQuadUpdate(e, 1, 1); }}
											/>
									</td>
								</tr>
								<tr>
									
								</tr>
							{/if}
							<tr>
								<td>
									<div class='layer-list-component'>
										<div class="layer-list-item">
											<div class='lli-label'>Opacity</div>
											<div class='lli-switch'>
												<input
													type="range"
													min="0"
													max="100"
													step="1"
													value={$opacity*100}
													style="margin-top:10px"
													on:input={(e) => {
														$opacity = parseFloat(e.target.value) * 0.01;
													}}>
											</div>
										</div>
									</div>
								</td>
							</tr>
						</table>

						{#if editable.geometryType === ImageGeometryType.EXTENT}
							<Button
								on:click={startDrawExtent}
								disabled={boxSelectEnabled}
								color="secondary"
								variant="unelevated"
								style={style+";margin-bottom:10px;"}>
								<Label>
									{#if !boxSelectEnabled}Draw Extent{:else}Click and drag on map to draw.{/if}
								</Label>
							</Button>
						{/if}

					</Cell>
				</Row>

			{/if}
		</Body>
	</DataTable>


	{#if canSubmit}
		{#if $loading == Loading.SAVING_IMAGE}
			<SpinnerButton style={style}/>
		{:else}
			<Button on:click={onSubmit}
				disabled={(image.isNew() && (files.accepted.length == 0 || $parsingLocalImageError.length > 0))} color="primary"
				variant="unelevated"
				style={style}><Label>{((image.isNew())?"Add Image":"Update Image")}</Label></Button>
		{/if}

		<Button on:click={()=>{
				onReset();
				tryUpdateBounds();
				tryAddImageToMap(); }} color="primary" class="bg-info" variant="unelevated" style={style}><Label>Reset</Label></Button>

		{#if !image.isNew()}
			<!-- <h2 style={style}>Actions</h2> -->
			<hr style={style}/>

			{#if $loading == Loading.DELETING_IMAGE || $loading == Loading.DISABLING_IMAGE}
				<SpinnerButton style={style}/>
			{:else}
				<Button color="secondary" variant="unelevated" class="bg-error" on:click={onDelete} style={style}><Label>Delete Image</Label></Button>
			{/if}
		{/if}
	{/if}


</Form>
